import clamp from './clamp';

// Calculation comes from this formula https://oag.ca.gov/sites/all/files/agweb/pdfs/cjsc/prof10/formulas.pdf
export function rate_perResidents(num, pop, rate) {
  return (num / pop) * rate;
}

export function cities(svg, topology, path) {
  const citylabels = svg.append('g').attr('class', 'citylabels');

  citylabels
    .selectAll('g')
    .data(topology.features)
    .enter()
    .append('g')
    .attr('class', 'city')
    .attr('transform', d => `translate(${path.centroid(d)})`);

  citylabels
    .selectAll('g')
    .append('circle')
    .attr('class', 'city-dot')
    .attr('fill', 'none')
    .attr('stroke', '#000')
    .attr('r', 3);

  citylabels
    .selectAll('g')
    .append('text')
    .attr('class', 'city-label')
    .attr('text-anchor', d => d.properties.anchor || 'middle')
    .attr('dx', d => d.properties.dx || '8')
    .attr('dy', d => d.properties.dy || '-8')
    .text(d => d.properties.name);
}

export function highways(svg, topology, path) {
  svg
    .selectAll('g')
    .data(topology.features.filter(d => d.properties.level == 'Interstate'))
    .enter()
    .append('path')
    .attr('class', 'highways')
    .attr('stroke', 'rgba(170, 170, 170, 1)')
    .attr('d', path);
}

export function add_legend_for_gray(legend, type, scale, isMobile) {
  const legend_for_gray = legend.append('g').attr('class', 'legend-gray');

  legend_for_gray
    .append('rect')
    .attr('class', 'counties')
    .attr('x', scale.range()[0] + (isMobile ? 20 : 0))
    .attr('height', 15)
    .attr('width', 30)
    .attr('fill', '#e8e8e8')
    .attr('stroke-width', '2')
    .attr('y', type == 'raw' ? 70 : 45);

  legend_for_gray
    .append('text')
    .attr('class', 'legend_gray_text')
    .attr('x', scale.range()[0] + (isMobile ? 60 : 40))
    .attr('y', type == 'raw' ? 80 : 55)
    .text('No reported cases');
}

// A tooltip function that relocates the tooltip when it gets to close to the edge

export function relocateTooltip(tooltip, x, y, screenY) {
  const tooltipPush = 25;
  const { height, width } = tooltip.node().getBoundingClientRect();

  const innerWidth = window.innerWidth;
  const innerHeight = window.innerHeight;

  const left = clamp(
    x - width / 2,
    tooltipPush,
    innerWidth - width - tooltipPush
  );

  const top =
    innerHeight > screenY + tooltipPush + height
      ? y + tooltipPush
      : y - height - tooltipPush;

  tooltip.style('left', `${left}px`);
  tooltip.style('top', `${top}px`);
}
